export enum ShipmentCategoryEnum {
    PARCEL = 'PARCEL',
    LTL = 'LTL'
}
